// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_page__9SiM7 {
  min-height: 100vh;
  padding: 1rem 1rem 2rem;
}

.styles_card__1jah2 {
  position: relative;
  max-width: 1500px;
  margin: 0.35rem auto 0;
  background: #ffffff;
  border-radius: 14px;
  padding: 1.1rem 1.35rem 0.6rem;
  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_infoGrid__qvKN\\+ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e1e6ee;
}

.styles_infoItem__4o9ZU {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #64748b;
}

.styles_infoItem__4o9ZU strong {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 600;
}


.styles_totalsRow__KvJVo {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.styles_totalCard__4yzMA {
  position: relative;
  border-radius: 12px;
  padding: 1.25rem;
  color: #0f172a;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid transparent;
  align-items: center;
  text-align: center;
}

.styles_totalCard__4yzMA span {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.styles_totalCard__4yzMA strong {
  font-size: 1.5rem;
  color: #ffffff;
}

.styles_totalEcd__k4lJU {
  background: #1e3a8a;
}

.styles_totalPis__IKWwW {
  background: #2563eb;
}

.styles_totalCofins__5RXAD {
  background: #dc2626;
}

.styles_totalCardReload__8saoM {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.styles_totalCardReload__8saoM:hover:not(:disabled) {
  opacity: 1;
  color: #ffffff;
  transform: scale(1.1);
}

.styles_totalCardReload__8saoM:active:not(:disabled) {
  transform: scale(0.95);
}

.styles_totalCardReload__8saoM:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.styles_iconRecarregarCard__JVoYv {
  font-size: 1.15rem !important;
  color: inherit;
}

.styles_filtrosContainer__dTLyn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0;
  flex-wrap: wrap;
}

.styles_filtrosRight__\\+aHSm {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.styles_avisoFiltroVazio__sUJxD {
  padding: 1rem 1.25rem;
  margin: 0.75rem 0;
  background: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  color: #92400e;
  font-size: 0.95rem;
}

.styles_botaoExportar__-ZsDL {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  background-color: #18316e !important;
  background: #18316e !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 1rem !important;
  font-family: "Inter" !important;
  font-weight: normal !important;
  cursor: pointer !important;
  transition: transform 0.3s ease-in-out !important;
  box-shadow: none !important;
  text-transform: none !important;
  height: 40px !important;
  min-width: 120px !important;
  text-align: center !important;
}

.styles_botaoExportar__-ZsDL:hover {
  transform: scale(1.1) !important;
}

.styles_botaoExportar__-ZsDL:active {
  background-color: #1976d2 !important;
  background: #1976d2 !important;
}

.styles_botaoExportar__-ZsDL:disabled {
  background-color: #6b6e76 !important;
  background: #6b6e76 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.styles_searchRow__aut9P {
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-start;
}

.styles_searchField__u0TCw {
  width: 320px;
}

.styles_searchIcon__Iin5W {
  color: #94a3b8;
}

.styles_footer__70Kg4 {
  margin-top: 0.15rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.3rem 0 0;
  border-top: 1px solid #e2e8f0;
}

.styles_footerLeft__6WXk1,
.styles_footerRight__q0XnE {
  display: flex;
  align-items: center;
}

.styles_paginationWrapper__yCSxv {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.styles_nextButton__\\+DYtn {
  background: #16a34a !important;
  padding: 0.45rem 1.8rem !important;
  font-weight: 600 !important;
}

@media (max-width: 768px) {
  .styles_page__9SiM7 {
    padding: 2rem 1rem;
  }

  .styles_card__1jah2 {
    padding: 1.5rem;
  }

  .styles_footer__70Kg4 {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_footerLeft__6WXk1,
  .styles_footerRight__q0XnE {
    justify-content: center;
  }

  .styles_paginationWrapper__yCSxv {
    width: 100%;
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/PreviaPISCOFINS/SobDespesas/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,iDAAiD;EACjD,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".page {\n  min-height: 100vh;\n  padding: 1rem 1rem 2rem;\n}\n\n.card {\n  position: relative;\n  max-width: 1500px;\n  margin: 0.35rem auto 0;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 1.1rem 1.35rem 0.6rem;\n  box-shadow: 0 10px 24px rgba(3, 15, 36, 0.14);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n  padding: 1.25rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e1e6ee;\n}\n\n.infoItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.9rem;\n  color: #64748b;\n}\n\n.infoItem strong {\n  color: #0f172a;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n\n.totalsRow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.totalCard {\n  position: relative;\n  border-radius: 12px;\n  padding: 1.25rem;\n  color: #0f172a;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  border: 1px solid transparent;\n  align-items: center;\n  text-align: center;\n}\n\n.totalCard span {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.totalCard strong {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n.totalEcd {\n  background: #1e3a8a;\n}\n\n.totalPis {\n  background: #2563eb;\n}\n\n.totalCofins {\n  background: #dc2626;\n}\n\n.totalCardReload {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.95);\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.totalCardReload:hover:not(:disabled) {\n  opacity: 1;\n  color: #ffffff;\n  transform: scale(1.1);\n}\n\n.totalCardReload:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.totalCardReload:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.iconRecarregarCard {\n  font-size: 1.15rem !important;\n  color: inherit;\n}\n\n.filtrosContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0;\n  flex-wrap: wrap;\n}\n\n.filtrosRight {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.avisoFiltroVazio {\n  padding: 1rem 1.25rem;\n  margin: 0.75rem 0;\n  background: #fef3c7;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  color: #92400e;\n  font-size: 0.95rem;\n}\n\n.botaoExportar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1.5rem;\n  background-color: #18316e !important;\n  background: #18316e !important;\n  color: #ffffff !important;\n  border: none !important;\n  border-radius: 4px !important;\n  font-size: 1rem !important;\n  font-family: \"Inter\" !important;\n  font-weight: normal !important;\n  cursor: pointer !important;\n  transition: transform 0.3s ease-in-out !important;\n  box-shadow: none !important;\n  text-transform: none !important;\n  height: 40px !important;\n  min-width: 120px !important;\n  text-align: center !important;\n}\n\n.botaoExportar:hover {\n  transform: scale(1.1) !important;\n}\n\n.botaoExportar:active {\n  background-color: #1976d2 !important;\n  background: #1976d2 !important;\n}\n\n.botaoExportar:disabled {\n  background-color: #6b6e76 !important;\n  background: #6b6e76 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n.searchRow {\n  margin-top: 0.5rem;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.searchField {\n  width: 320px;\n}\n\n.searchIcon {\n  color: #94a3b8;\n}\n\n.footer {\n  margin-top: 0.15rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  padding: 0.3rem 0 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n.footerLeft,\n.footerRight {\n  display: flex;\n  align-items: center;\n}\n\n.paginationWrapper {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.nextButton {\n  background: #16a34a !important;\n  padding: 0.45rem 1.8rem !important;\n  font-weight: 600 !important;\n}\n\n@media (max-width: 768px) {\n  .page {\n    padding: 2rem 1rem;\n  }\n\n  .card {\n    padding: 1.5rem;\n  }\n\n  .footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .footerLeft,\n  .footerRight {\n    justify-content: center;\n  }\n\n  .paginationWrapper {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `styles_page__9SiM7`,
	"card": `styles_card__1jah2`,
	"infoGrid": `styles_infoGrid__qvKN+`,
	"infoItem": `styles_infoItem__4o9ZU`,
	"totalsRow": `styles_totalsRow__KvJVo`,
	"totalCard": `styles_totalCard__4yzMA`,
	"totalEcd": `styles_totalEcd__k4lJU`,
	"totalPis": `styles_totalPis__IKWwW`,
	"totalCofins": `styles_totalCofins__5RXAD`,
	"totalCardReload": `styles_totalCardReload__8saoM`,
	"iconRecarregarCard": `styles_iconRecarregarCard__JVoYv`,
	"filtrosContainer": `styles_filtrosContainer__dTLyn`,
	"filtrosRight": `styles_filtrosRight__+aHSm`,
	"avisoFiltroVazio": `styles_avisoFiltroVazio__sUJxD`,
	"botaoExportar": `styles_botaoExportar__-ZsDL`,
	"searchRow": `styles_searchRow__aut9P`,
	"searchField": `styles_searchField__u0TCw`,
	"searchIcon": `styles_searchIcon__Iin5W`,
	"footer": `styles_footer__70Kg4`,
	"footerLeft": `styles_footerLeft__6WXk1`,
	"footerRight": `styles_footerRight__q0XnE`,
	"paginationWrapper": `styles_paginationWrapper__yCSxv`,
	"nextButton": `styles_nextButton__+DYtn`
};
export default ___CSS_LOADER_EXPORT___;
